import * as React from 'react'

import { SchoolAdminInterface, } from './interfaces'

import AdminTable from '../../shared/adminTable'
import { requestPost, } from '../../../../../modules/request'
import { Input, } from '../../../../Shared/index'
import useModalAccessibility from '../../../../Shared/hooks/useModalAccessibility'

interface AdminRequestModalProps {
  onSuccess: (string) => void;
  closeModal: () => void;
  schoolAdmins: SchoolAdminInterface[]
  schoolName: string;
}

const AdminRequestModal = ({ onSuccess, schoolAdmins, closeModal, schoolName, }: AdminRequestModalProps) => {
  const { modalRef, } = useModalAccessibility(closeModal)

  const [selectedAdminIds, setSelectedAdminIds] = React.useState<number[]>([])
  const [message, setMessage] = React.useState<string>('')

  function handleChangeMessage(e) { setMessage(e.target.value) }

  function handleClickSendRequest() {
    requestPost(`${window.postbuildEnv.DEFAULT_URL}/teacher_infos/request_teacher_verification`, {
      admin_ids: selectedAdminIds,
      message
    }, () => {
      onSuccess("Your request has been sent. Once verified, you'll receive a confirmation email.")
    })
  }

  let sendRequestButton = <button className="quill-button medium primary contained focus-on-light" onClick={handleClickSendRequest} type="button">Send request</button>

  if (selectedAdminIds.length === 0) {
    sendRequestButton = <button className="quill-button medium primary contained focus-on-light disabled" disabled type="button">Send request</button>
  }

  return (
    <div className="modal-container admin-request-modal-container">
      <div className="modal-background" />
      <div
        aria-labelledby="requestVerificationModal"
        aria-modal={true}
        className="admin-request-modal quill-modal modal-body"
        ref={modalRef}
        role="dialog"
        tabIndex={-1}
      >
        <h3 id="requestVerificationModal">Request verification</h3>
        <p>Which admin(s) do you want to send this request to? They will receive an email asking them to confirm you are a teacher at {schoolName}.</p>
        <AdminTable schoolAdmins={schoolAdmins} selectedAdminIds={selectedAdminIds} setSelectedAdminIds={setSelectedAdminIds} />
        <Input
          className="message"
          handleChange={handleChangeMessage}
          id="message-to-admin"
          label="Message to admin(s) (optional)"
          value={message}
        />
        <div className="button-section">
          <button className="quill-button medium secondary outlined focus-on-light" onClick={closeModal} type="button">Cancel</button>
          {sendRequestButton}
        </div>
      </div>
    </div>
  )
}

export default AdminRequestModal
